import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	watchedByMe: {
		id: 'search-page.filters.names.watchedByMe',
		defaultMessage: 'Show my watched items',
		description: 'Label for filtering for watched by me items',
	},
});
